import { ListingHeaderLink } from "./ListingHeaderLink";
import { ListingHeaderWrapper } from "./ListingHeaderWrapper";
import { ListingHeaderTitleScoreContainer } from "./ListingHeaderTitleScoreContainer";
import { ListingHeaderTitle } from "./ListingHeaderTitle";
import { ListingStarRating } from "./ListingStarRating";
import { ListingShareWishlistContainer } from "./ListingShareWishlistContainer";
import { ListingShare, ShareProvider } from "../trainingShare";
import { ListingSave } from "../ListingSave";

export const ListingHeaderSection = () => {
  return (
    <ListingHeaderWrapper>
      <ListingHeaderTitleScoreContainer>
        <ListingHeaderLink />
        <ListingHeaderTitle />
        <ListingStarRating />
      </ListingHeaderTitleScoreContainer>

      <ListingShareWishlistContainer>
        <ShareProvider>
          <ListingShare />
        </ShareProvider>

        <ListingSave />
      </ListingShareWishlistContainer>
    </ListingHeaderWrapper>
  );
};
